import { render, staticRenderFns } from "./CommunityCircle.vue?vue&type=template&id=63a993f3&scoped=true&"
import script from "./CommunityCircle.vue?vue&type=script&lang=js&"
export * from "./CommunityCircle.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCircle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CommunityCircle.vue?vue&type=style&index=1&id=63a993f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a993f3",
  null
  
)

export default component.exports